import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Config } from '../../config/config';

@Injectable({
    providedIn: 'root'
})
export class HamiltonService {

    private _config: Config = new Config();

    constructor(private http: HttpClient) { }

    public getClients(): Observable<any> {
        return this.http.get<any>(`${this._config.get('urlServiceBackend')}hamilton/report/clients`)
    }

    public getStackTraces(reportId): Observable<any> {
        return this.http.get<any>(`${this._config.get('urlServiceBackend')}hamilton/report/open/${reportId}/stack-traces`)
    }

    public postResolveReport(data): Observable<any> {
        return this.http.post<any>(`${this._config.get('urlServiceBackend')}hamilton/report/resolve`, data)
    }

    public getReportByClient(clientId): Observable<any> {
        return this.http.get<any>(`${this._config.get('urlServiceBackend')}hamilton/report/open/by-client/${clientId}`)
    }

}
